import React, { createContext, useState, useContext } from 'react';
import { getFromAPI } from '../../Utils/utils';


// Create Context
export const VendorContext = createContext();

// Custom hook to use the CustomerContext
export const useVendor = () => useContext(VendorContext);

// Create a Context Provider component
export const VendorProvider = ({ children }) => {
    const [vendor, setVendor] = useState([]);

    const fetchVendorData = async () => {
        try {
            const response = await getFromAPI('FtsVendor/');
            setVendor(response);
        } catch (error) {
            console.error('Error fetching vendor data:', error);
        }
    };

    return (
        <VendorContext.Provider value={{ vendor, fetchVendorData }}>
            {children}
        </VendorContext.Provider>
    );
};
